import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";
import { projectsvtp } from "../../../../data/projects/vtp/data";
import Main_Footer from "../../../../components/footer/IndiaFooter/Main_Footer";
import { linkifyKeywords } from "../../../../utils/linkifyKeywords";

export const Monarque = () => {
  const {
    monarque: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
    },
  } = projectsvtp;

  if (
    !bannerdata ||
    !overview ||
    !pricing ||
    !floor_plan ||
    !highlights ||
    !location ||
    !gallery ||
    !faq
  ) {
    return <div>Loading...</div>; // or an error page, depending on your needs
  }

  const overviewWithLinkedKeywords = {
    ...overview,
    description: overview.description.map((para) =>
      linkifyKeywords(para, overview.keywordLinks)
    ),
  };

  return (
    <>
      <Helmet>
        <title>
          VTP Monarque Hinjewadi, Pune | Luxury 2, 3 & 4.5 BHK Apartments with
          Modern Amenities
        </title>
        <meta
          name="keywords"
          content="VTP Monarque Hinjewadi, VTP Monarque Pune, luxury apartments Hinjewadi, 2 BHK flats Pune, 3 BHK flats Pune"
        />
        <meta
          name="description"
          content="Experience premium living at VTP Monarque in Hinjewadi Phase 1, Pune. Choose from spacious 2, 3, and 4.5 BHK residences with maximum livable area"
        />
        <meta name="author" content="VTP Group" />
        <link rel="canonical" href="https://propertystation.in/vtp-monarque" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview
          overviewData={overviewWithLinkedKeywords}
          stripdata={overview.stripdata}
        />
        <SiteVisitBanner formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        {/* <SimilarProject Similarprojects={similar} /> */}
        <Main_Footer />
      </div>
    </>
  );
};
